// extracted by mini-css-extract-plugin
module.exports = {"title":"_c51b8e8","groupTitle":"_44251dd7","list":"_64a0314a","listItem":"_b2e4439f","link":"_300486e8","imageWrapper":"_8dbd9d1c","image":"_a266cc8f","itemTitle":"_1a1c86bd"};